import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_ADVSEARCH_PARAM, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_STATUS, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funGetPageAction, GetLoginCredentialDb, getModMandatory, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Chip,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Select,
  SelectItem,
  useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCircleXmark,
  faEdit,
  faFileInvoice,
  faHexagonNodes,
  faPlus,
  faPrint,
  faReceipt,
  faStamp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setMemoDetail, setMemoParams, setModSettingData, setNewEntryMode, setReportData } from "../../state/memoEntrySlice"
import { Drawer } from "@mui/material"
import ReportViewer from "../report/ReportViewer"
import { enum_Report_Type } from "../report/ReportUtility"
import { resetReportData } from "../../state/invoiceEntrySlice"

const MemoEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId, } = useSelector((state) => state.company)
  const { user, token } = useSelector((state) => state.auth)
  const [itemToDelete, setItemToDelete] = useState("")
  const [itemToEdit, setItemToEdit] = useState("")
  const { btype, trdtype, ptype } = useParams()
  const [entryLabel, setEntryLabel] = useState()
  const [selBillType, setSelBillType] = useState()
  const [selTradeOf, setSelTradeOf] = useState()
  const [selModName, setSelModName] = useState()
  const [selPktType, setSelPktType] = useState()
  const [naviCode, setnaviCode] = useState()
  const [selFilterStatus, setSelFilterStatus] = useState(new Set(
    [String(ENUM_STATUS.Pending), String(ENUM_STATUS.PartialFinal), String(ENUM_STATUS.PartialReturn)]))
  const [data, setData] = useState([])
  const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
  const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
  const [CurrencySetting, setCurrencySetting] = useState("")
  const [pageActionType, setPageActionType] = useState("")



  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()
  //console.log(selFilterStatus, selFilterStatus.size)
  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard)
    disapatch(resetDetailParams())
    disapatch(resetReportData())

  }, [])
  const isSinglePacket = () => {
    if (ptype != "") {
      if (ptype == URIEncrypt.SinglePacket)
        return true
      else
        return false
    }
    else
      return false
  }
  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingCurrency",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })
  useEffect(() => {
    if (modSetting && modSetting.length > 0) {
      const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
      setIsUseMfgNoAsMktno(mktSetting)
      const currSetting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting) ?? ENUM_CURRENCY_SETTING_VAL.RS;
      setCurrencySetting(currSetting)
    }
  }, [modSetting])

  useEffect(() => {

    const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
    if (!params.includes(String(trdtype))
      || ![URIEncrypt.Sale, URIEncrypt.Purchase].includes(String(btype))
      || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(String(ptype))
    )
      navigate(linksUrl.dashboard)

    if (btype && btype != "" && trdtype && trdtype != "" || ptype && ptype != "") {

      let t_trdtype = trdtype
      let t_btype = btype
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_billtype = ''
      let t_ptype = ''
      let modName = ""


      if (ptype == URIEncrypt.SinglePacket)
        t_ptype = 'SNG'
      else
        t_ptype = 'MIX'

      if (t_btype == URIEncrypt.Sale) {
        t_billtype = 'S'
      }
      else if (t_btype == URIEncrypt.Purchase) {
        t_billtype = 'P'
      }
      if (t_trdtype == URIEncrypt.Polish) {
        t_tradeof = ENUM_TRADEOF_CODE.Polish
        t_entryLabel = "Polish Diamond "
        if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SalePolishMemoSingle : ENUM_MOD_NAME.SalePolishMemoMix }
        else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchasePolishMemoSingle : ENUM_MOD_NAME.PurchasePolishMemoMix }
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.polishDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.polishDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rough) {
        t_tradeof = ENUM_TRADEOF_CODE.Rough
        t_entryLabel = "Rough Diamond "
        if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRoughMemoSingle : ENUM_MOD_NAME.SaleRoughMemoMix }
        else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRoughMemoSingle : ENUM_MOD_NAME.PurchaseRoughMemoMix }
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rejection) {
        t_tradeof = ENUM_TRADEOF_CODE.Rejection
        t_entryLabel = "Rejection Diamond "
        if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRejectionMemoSingle : ENUM_MOD_NAME.SaleRejectionMemoMix }
        else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRejectionMemoSingle : ENUM_MOD_NAME.PurchaseRejectionMemoMix }
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.rejectDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.rejectDiamond : "")
      }

      setSelTradeOf(t_tradeof)
      setSelBillType(t_billtype)
      setEntryLabel(t_entryLabel)
      setSelPktType(t_ptype)
      setSelModName(modName)
      funFilterData(t_billtype, t_tradeof, t_ptype, null, null, null, null, null, null);
      setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: t_billtype, TradeOf: t_tradeof })
    }


  }, [btype, trdtype, ptype])

  const FILTER_STATUS = [
    { value: "Final", key: [ENUM_STATUS.Final] },
    { value: "Pending", key: [ENUM_STATUS.Pending] },
    { value: "Partial Final", key: [ENUM_STATUS.PartialFinal] },
    { value: "Return", key: [ENUM_STATUS.Return] },
    { value: "Partial Retrun", key: [ENUM_STATUS.PartialReturn] }
  ]

  const {
    isError,
    isPending,
    data: memoData = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.memoEntry.fetch,
    queryKey: "Memo Data List",

  })

  useEffect(() => {
    let newData = memoData
    if (memoData && memoData.length > 0) {
      if (selFilterStatus.size == 0)
        setData(memoData)
      else {
        const selStatus = selFilterStatus
        newData = memoData.filter(ele => selStatus.has(ele.status))
        setData(newData)
      }
    }
    else
      setData(memoData)
    //if (selFilterStatus.size == 0) {
    // setData(memoData)
    // setSelFilterStatus(new Set([String(ENUM_STATUS.Pending), String(ENUM_STATUS.PartialFinal)]))
    // }
  }, [memoData, selFilterStatus])
  const funFilterData = (billtype, tradeof, pkttype, scode, qcode, szcode, shcode, lwcode, itemcode, pacid, brid, fromdate, todate) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        billtype: billtype,
        tradeof: tradeof,
        pkttype: pkttype == 'SNG' ? pkttype : '',
        s_code: scode,
        q_code: qcode,
        sh_code: shcode,
        sz_code: szcode,
        lw_code: lwcode,
        item_code: itemcode,
        pac_id: pacid,
        br_id: brid,
        from_date: fromdate,
        to_date: todate

      }
    })

  }

  const onSuccessDelete = (data) => {
    setItemToDelete("")

    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Memo can't be delete as it locked", {
          position: "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center",
          "className": "toast-error",
        })
        funFilterData(selBillType, selTradeOf, selPktType, null, null, null, null, null, null, null, null, null, null);
      }

    }

  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.memoEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmt",
      }),
    [data]
  )
  let totalAmtD = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmtD",
      }),
    [data]
  )
  let totalBalWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "BalWeight",
      }),
    [data]
  )
  console.log(data, "d")
  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "Party_Name",
    "Memo_Det",
    "Chal_No",
    "NetAmt",
    "NetAmtD",
    "BalWeight",
    "AvgRateD",
    "AvgRate",
    "Chal_Date",
    "Account_Name",
    "status"

  ]

  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "Party_Name",
    },
    {
      name: "Description",
      uid: "Memo_Det",
    },
    {
      name: "MEMO NO",
      uid: "Chal_No",
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      type: COLUMN_TYPE.number
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      type: COLUMN_TYPE.number

    },
    {
      name: "Bal Weight",
      uid: "BalWeight",
      type: COLUMN_TYPE.number
    },
    {
      name: "Avg Rate($)",
      uid: "AvgRateD",
      type: COLUMN_TYPE.number
    },
    {
      name: "Avg Rate",
      uid: "AvgRate",
      type: COLUMN_TYPE.number
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
    },
    {
      name: "Status",
      uid: "status",
    },
  ]
  const [exportCols, setExportCols] = useState(exportColumns)

  let downloadDataFooter = {
    Party_Name: "",
    Memo_Det: "",
    Memo_No: "",
    NetAmt: "Total: " + totalAmt,
    NetAmtD: "Total: " + totalAmtD,
    BalWeight: "Total:" + totalBalWeight,
    AvgRateD: "",
    AvgRate: "",
    Date: "",
    Account: "",
  }

  const [exportFooter, setExportFooter] = useState(downloadDataFooter)

  useEffect(() => {
    if (CurrencySetting && CurrencySetting != "") {
      let AmtColumn = []
      if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
        AmtColumn = ["NetAmtD", "AvgRateD"]
      else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        AmtColumn = ["NetAmt", "AvgRate"]
      else {
        setInitialColumn(INITIAL_VISIBLE_COLUMNS)
        setExportCols(exportColumns)
        setExportFooter(downloadDataFooter)
      }

      if (AmtColumn.length > 0) {
        const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
        const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
        //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
        const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => !AmtColumn.includes(ele))
        setExportCols(filterExpCol)
        setInitialColumn(filterIniCol)
        setExportFooter(filterExpFooter)
      }
    }
  }, [CurrencySetting])

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "Party_Name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Description",
      uid: "Memo_Det",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left,
      type: COLUMN_TYPE.multiline
    },
    {
      name: "MEMO NO",
      uid: "Chal_No",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmtD,
      },
    },
    {
      name: "Bal Weight",
      uid: "BalWeight",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalWeight,
      },
    },

    {
      name: "Avg Rate($)",
      uid: "AvgRateD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,

    },
    {
      name: "Avg Rate",
      uid: "AvgRate",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Status",
      uid: "status",
      align: COLUMN_ALIGN_TYPE.center,

    },
  ]
  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="3xl"
          scrollBehavior="inside"
          placement="center"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="m-0 px-2 bg-gray-100 border-b-2 border-gray-700">
                  {`${selBillType == "S" ? "Sale" : "Purchase "} ${entryLabel}  Memo  (${selPktType == 'SNG' ? "Single" : "Mix"})`}
                </ModalHeader>
                <ModalBody>
                  <ReportViewer props_ReportType={enum_Report_Type.MEMO} />
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }
  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {

        FndeleteNote({
          data: {
            transaction_id: itemToDelete.transaction_id,
            comp_code: itemToDelete.comp_code,
            pkt_type: itemToDelete.pkt_type,
            bill_type: itemToDelete.bill_type,
            trade_of: selTradeOf,
            mkt_lotno: isUseMfgNoAsMktno ? '0' : "1"

          }
        })
      }
      else if (itemToEdit != "" && itemToEdit != null && Object.keys(itemToEdit).length > 0) {
        disapatch(setDetailParams(itemToEdit))
        disapatch(setNewEntryMode(false))
        if (selPktType == 'MIX')
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)
        else
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.createMemoEntry)
      }

    }
    else {
      setItemToDelete("")
      setItemToEdit("")
      setPageActionType("")
    }

  }

  const rowActionBtn = [

    {
      icon: <FontAwesomeIcon color="#FFFFFF" icon={faHexagonNodes} />,
      //1656e7
      onClick: (row) => {
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of,
          status: row.status

        }

        disapatch(setMemoParams(obj))

        navigate(linksUrl.memoEntry.memoEntryMaster + "/" + btype + "/" + trdtype + "/" + ptype + linksUrl.memoFinalizeEntry)

      },
      label: "Action",
      color: "bg-red-700",
      type: ROW_ACTION_BTN_TYPE.button,
    },
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        setItemToDelete("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of,
          status: row.status

        }
        setItemToEdit(obj)

        // disapatch(setDetailParams(obj))
        /// disapatch(setNewEntryMode(false))
        // if (selPktType == 'MIX')
        //   navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)
        // else
        //   navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.createMemoEntry)


      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        if (row.status == "Pending") {
          setItemToEdit("")
          setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
          setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, pkt_type: row.PktType, bill_type: row.Bill_Type })
        }
        else {
          toast.error("Memo can't be delete as it locked", {
            "position": "top-center",
            "className": "toast-error",
          })
        }
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c511b7" icon={faPrint} />,
      onClick: (row) => {
        let obj = {
          comp_code: row.CompCode,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of,
          trans_id: row.TransactionId,
          token: token,
          db_user: GetLoginCredentialDb(user, yearId)

        }
        let objMod = {
          mod_name: selModName,
          token: token,
          db_user: GetLoginCredentialDb(user, yearId)
        }
        disapatch(setMemoDetail(obj))
        disapatch(setModSettingData(objMod))
        onOpenReportModel()
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },

  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    if (selPktType == 'MIX')
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)
    else
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.createMemoEntry)

  }
  const ADVFILTER_VISIBLE_FIELD = [
    // ...Object.values(ENUM_ADVSEARCH_PARAM)
    ENUM_ADVSEARCH_PARAM.Shape,
    ENUM_ADVSEARCH_PARAM.Purity,
    ENUM_ADVSEARCH_PARAM.Color,
    ENUM_ADVSEARCH_PARAM.Size,
    ENUM_ADVSEARCH_PARAM.Party,
    ENUM_ADVSEARCH_PARAM.Broker,
    ENUM_ADVSEARCH_PARAM.Item,
    ENUM_ADVSEARCH_PARAM.LwRatio,
    ENUM_ADVSEARCH_PARAM.VouFromDate,
    ENUM_ADVSEARCH_PARAM.VouToDate,
    //ENUM_ADVSEARCH_PARAM.VouNo,
  ]
  const handleFilterChange = (newFilters) => {
    //console.log('Received filters in parent:', newFilters);
    setSelAdvanceFilter(newFilters)
    funFilterData(selBillType, selTradeOf, selPktType,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Shape) ? newFilters[ENUM_ADVSEARCH_PARAM.Shape] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Purity) ? newFilters[ENUM_ADVSEARCH_PARAM.Purity] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Size) ? newFilters[ENUM_ADVSEARCH_PARAM.Size] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Color) ? newFilters[ENUM_ADVSEARCH_PARAM.Color] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.LwRatio) ? newFilters[ENUM_ADVSEARCH_PARAM.LwRatio] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Party) ? newFilters[ENUM_ADVSEARCH_PARAM.Party] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Broker) ? newFilters[ENUM_ADVSEARCH_PARAM.Broker] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,

    )

  };

  const handleChange = (e) => {
    setSelFilterStatus(new Set(e.target.value.split(",")));
  }
  const handleDelet = (key) => {
    const newFilter = selFilterStatus
    newFilter.delete(key)
    setSelFilterStatus(new Set(newFilter));
  }



  return (
    <div>

      {(itemToDelete || itemToEdit) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
          actionType={pageActionType}
        />
      )}


      <MainContainer
        pageName={entryLabel + `Memo - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
        info={[]}
        breadcrumbs={[selBillType == 'S' ? 'Sale' : 'Purchase', entryLabel, "Memo", selPktType == 'SNG' ? "Single Packet" : selPktType]}
      >

        <div className="flex justify-between" >
          <div className="w-full">
            <Select
              className="w-full "
              isMultiline={true}
              color="default"
              classNames={{
                base: "max-w-md",
                label: "font-semibold"
                //trigger: "min-h-5 py-2",
              }}
              items={FILTER_STATUS}
              label="Memo Status"
              labelPlacement="outside"
              size="sm"
              renderValue={(items) => {
                return (
                  <div className="flex flex-wrap gap-2" >
                    {items.map((item) => (
                      <div key={item.key} className="flex">
                        <Chip size="sm" radius="sm" variant="flat" color="default" key={item.key}><strong> {item.data.value}</strong></Chip>
                        <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key)} icon={faCircleXmark} /></div>
                    ))}
                  </div>
                );
              }}

              selectedKeys={selFilterStatus}
              selectionMode="multiple"
              onChange={handleChange}
              variant="bordered"
            >
              {(list) => (
                <SelectItem
                  key={list.key}
                >
                  {list.value}
                </SelectItem>
              )}
            </Select>
          </div>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>
        {reportModel()}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={initialColumn}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportCols}
          downloadDataFooter={exportFooter}
          downloadFileName={entryLabel + "Memo-List"}
          onFilterChange={handleFilterChange}
          showAdvancedFilter={true}
          id="TransactionId"
          advanceFilterParam={selAdvanceFilter}
          advFilterPageApiParam={pageApiAdvFilter}
          advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default MemoEntryMaster
